var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1404.98 1504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #c31c94;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1389,1504h-310.7v-654.58c0-34.33-4.61-63.08-19-82.3-13.8-18.44-38-29.21-78.14-29.21-129.83,0-162.3,98.42-166.49,113.36v652.73h-326.62V438.37h326.63v84.36c27.3-17.71,56.2-32.84,86.3-45.2,61.31-25.32,126.99-38.38,193.32-38.43,60.78,0,160.81,21.69,231.19,117.93,46.25,63.24,79.49,158.59,79.49,301v645.97h-16,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.81,309.53c-85.47-.2-154.6-69.65-154.4-155.12,0,0,0,0,0-.01C9.44,69.14,78.55.03,163.81,0l.13.06c40.94.34,80.12,16.76,109.06,45.72,28.92,28.75,45.19,67.84,45.21,108.62.23,85.45-68.86,154.9-154.31,155.13-.03,0-.06,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "311.62 1504 16 1504 0 1504 0 1488 0 454.37 0 438.37 16 438.37 311.62 438.37 327.62 438.37 327.62 454.37 327.62 1488 327.62 1504 311.62 1504"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinPink);
export default __webpack_public_path__ + "static/media/linkedin-pink.28205e73b782284a4c306069927e18f8.svg";
export { ForwardRef as ReactComponent };